import React from "react";
import { Link } from "react-router-dom";
import { slugify } from "../../../utils";

const PropOne = ({ projectStyle, portfolio, isHomePage }) => {
  // Function to check if the screen width is for tablet or above
  const isTabletOrAbove = () => {
    return window.innerWidth >= 768; // 768px is a common breakpoint for tablets
  };

  return (
    <div className={`project-grid ${projectStyle}`}>
      <div className="thumbnail">
        {isHomePage ? (
          <Link to={portfolio.link}>
            <img 
              src={process.env.PUBLIC_URL + portfolio.image} 
              alt={portfolio.title || "Project"} 
              loading="lazy"
            />
          </Link>
        ) : (
          <img 
            src={process.env.PUBLIC_URL + portfolio.image} 
            alt={portfolio.title || "Project"} 
            loading="lazy"
          />
        )}
      </div>
      <div
        className="content"
        style={
          !isHomePage && isTabletOrAbove() 
            ? { 
                minHeight: "450px",
                WebkitMinHeight: "450px",
                display: "flex",
                flexDirection: "column"
              } 
            : { 
                minHeight: "0",
                WebkitMinHeight: "0",
                display: "flex",
                flexDirection: "column"
              }
        }
      >
        <h4 className="title">
          {isHomePage ? (
            <Link to={portfolio.link}>{portfolio.title}</Link>
          ) : (
            <>{portfolio.title}</>
          )}
        </h4>
        <span className="subtitle">
          {isHomePage ? (
            <div className="truncated-text">{portfolio.body}</div>
          ) : (
            <div>{portfolio.body}</div>
          )}
        </span>
      </div>
    </div>
  );
};

export default PropOne;